import { db } from '../firebase';

type Updates = {
  mapType?: string;
  mappedOn?: Date;
};

export const updateTileset = (
  orgId: string,
  phase1Id: string,
  phase2Id: string,
  tilesetDocId: string,
  updates: Updates
) => {
  db.collection('organizations')
    .doc(orgId)
    .collection('phase1')
    .doc(phase1Id)
    .collection('phase2')
    .doc(phase2Id)
    .collection('tilesets')
    .doc(tilesetDocId)
    .update(updates)
    .then((doc) => console.log('Tileset correctly updated'));
};
